import { render } from "./ContactBlock.vue?vue&type=template&id=26473273&scoped=true"
import script from "./ContactBlock.vue?vue&type=script&lang=js"
export * from "./ContactBlock.vue?vue&type=script&lang=js"

import "./ContactBlock.vue?vue&type=style&index=0&id=26473273&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26473273"]])

export default __exports__